module.exports = __webpack_public_path__ + "media/newstyle/images/50-countries-ea7a94ca1c8cb800ca2d2a36b5be74ce.svg";